module.exports = __webpack_public_path__ + "static/media/bg.87c2c234.jpg";